<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          
          <!-- <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/pump-types-edit/'+selected[0].idpump_type_info)"
          >Edit</v-btn>

          <v-btn v-if=" selected.length > 0" text @click="deletePumpTypeInfo" color="red">Delete</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-types-add')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Type
          </v-btn>
            
          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-type-add-from-excell')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Types & Pumps From Excell
          </v-btn> -->
          
          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
         {{$t('pump_type_infos')}}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idpump_type_info"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="pumpTypeInfos"
          :search="search"
        >





 <template v-slot:top>
            <v-toolbar flat color="white">
              
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="1000px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('new_pump_type_info')}}</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>


 <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.type" :label="$t('type_starts_with')" required></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.frequency" label="Frequency" suffix="Hz" required></v-text-field>
        </v-col> -->

        
      </v-row>
      <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="editedItem.max_sand_quantity"
            suffix="gr/m^3"
            :label="$t('pump.max_sand_quantity')"
          ></v-text-field>
        </v-col>
         
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.number_of_vane" suffix="" :label="$t('pump.number_of_vane')"></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.degree_of_protection" suffix="" label="Degree Of Protection"></v-text-field>
        </v-col> -->

        <v-col v-if="false" cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.voltage" suffix="V" :label="$t('motor.voltage')"></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="editedItem.rotation" suffix="" :label="$t('pump.rotation')"></v-text-field>
        </v-col>
        
      </v-row>

      <v-row>
        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="editedItem.max_water_temp"
            suffix="C"
            label="Maximum Water Temp"
          ></v-text-field>
        </v-col> -->

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.material" suffix="" :label="$t('pump.material')"></v-text-field>
        </v-col>
           <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.case" suffix="" :label="$t('pump.case')"></v-text-field>
        </v-col>
        
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.diffuser" suffix="" :label="$t('pump.diffuser')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.impeller" suffix="" :label="$t('pump.impeller')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.pump_shaft" suffix="" :label="$t('pump.pump_shaft')"></v-text-field>
        </v-col>


        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.fi_r" suffix="mm" label="Pump Outside Diameter"></v-text-field>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.fi_e" suffix='"' label="Outlet Connection Diameter"></v-text-field>
        </v-col>
 -->


        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.coupling" suffix="" :label="$t('pump.coupling')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.strainer" suffix="" :label="$t('pump.strainer')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.valve_cap" suffix="" :label="$t('pump.valve_cap')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="editedItem.connection" suffix="" :label="$t('pump.connection')"></v-text-field>
        </v-col>
         
        
      </v-row>











                       
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{$t('cancel')}}</v-btn>
                    <v-btn color="blue darken-1" text @click="save">{{$t('save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>




        <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>

        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    dialog: false,
    selected: [],
    editPumpTypeInfoId: 100,
    search: "",
    pumpTypeInfos: [],
    editedIndex: -1,
    editedItem: {
      idpump_type_info: -1,
      material: "",
      type: "",
      frequency: "",
      outlet_connection_diameter: "",
      max_sand_quantity : "",
      pump_outside_diameter : "",
      number_of_vane : "",
      degree_of_protection : "",
      voltage : "",
      rotation : "",
      max_water_temp : "",
      case : "",
      diffuser : "",
      impeller :  "",
      pump_shaft  : "",
      coupling :  "",
      strainer :  "",
      valve_cap : "",
      connection : "Based on NEMA Standarts"
    } ,
        defaultItem: {
      idpump_type_info: -1,
      material: "",
      type: "",
      frequency: "",
      outlet_connection_diameter: "",
      max_sand_quantity : "",
      pump_outside_diameter : "",
      number_of_vane : "",
      degree_of_protection : "",
      voltage : "",
      rotation : "",
      max_water_temp : "",
      case : "",
      diffuser : "",
      impeller :  "",
      pump_shaft  : "",
      coupling :  "",
      strainer :  "",
      valve_cap : "",
      connection : "Based on NEMA Standarts"
    } 
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('new_pump_type_info') : this.$t('edit_pump_type_info');
    },
    headers() { return [
      {
        text: this.$t('type_starts_with'),
        align: "left",
        sortable: true,
        value: "type",
        width: 120
      },

      // { text: "Frequency (Hz)", value: "frequency" },
      // { text: "Outlet Connection Diameter (\")", value: "fi_e" },
      { text: this.$t('pump.max_sand_quantity') +" (gr/m^3)", value: "max_sand_quantity", width: 150 },
      // { text: "Pump Outside Diameter (mm)", value: "fi_r" },
      { text: this.$t('pump.material'), value: "material", width: 140 },
      { text: this.$t('pump.number_of_vane'), value: "number_of_vane" },
      // { text: "Degree Of Protection", value: "degree_of_protection" },
      // { text: this.$t('motor.voltage'), value: "voltage" },
      { text: this.$t('pump.rotation'), value: "rotation" },
      // { text: "Max. Water Temp (C)", value: "max_water_temp"},
      { text: this.$t('pump.case'), value: "case"},
      { text: this.$t('pump.diffuser'), value: "diffuser"},
      { text: this.$t('pump.impeller'), value: "impeller"},
      { text: this.$t('pump.pump_shaft'), value: "pump_shaft"},
      { text: this.$t('pump.coupling'), value: "coupling"},
      { text: this.$t('pump.strainer'), value: "strainer"},
      { text: this.$t('pump.valve_cap'), value: "valve_cap"},
      { text: this.$t('pump.connection'), value: "connection" },
      { text: this.$t('actions'), value: "action", sortable: false }
    ]},
     
  },

  watch: { 
    dialog(val) {
      val || this.close();
    },
     
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypeInfos();
  },
  methods: {

editItem(item) {
      this.editedIndex = this.pumpTypeInfos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.selected = [item];
      this.deletePumpTypeInfo();
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        // Object.assign(this.users[this.editedIndex], this.editedItem);
        this.savePumpTypeInfo(true, this.editedItem);
      } else {
        // save new
        // this.users.push(this.editedItem);
        this.savePumpTypeInfo(false, this.editedItem);
      }
    },

    savePumpTypeInfo: function(isUpdate, item) {
      var targetUrl = isUpdate == false ? "save_pump_type_info" : "update_pump_type_info";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: item
      })
        .then(response => {
          if (response.data == "1")
          this.close();
          this.fetchPumpTypeInfos()
        })
        .catch(function(error) {
          alert(error);
        });
    },

    deletePumpTypeInfo: function() {
      confirm(this.$t('confirm_delete')) &&
        this.selected.forEach(this.deletePumpTypeInfoRequest);
      this.selected = [];
    },
    deletePumpTypeInfoRequest: function(pumpType) {
      this.$http
        .get(this.$API_URL + "pump-type-info-delete?idpump_type_info=" + pumpType.idpump_type_info)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchPumpTypeInfos();
        });
    },
    fetchPumpTypeInfos: function() {
      this.$http.get(this.$API_URL + "pump_types_infos").then(result => {
        this.pumpTypeInfos = result.data;
      });
    }
  }
};
</script>
